import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { Observable, forkJoin, shareReplay, tap, map, catchError, throwError } from 'rxjs';
import { dashboardFilters } from 'src/services/api-services/api-interfaces/dashboardFilters.interface';
import { Graph } from 'src/services/api-services/api-interfaces/graphDashboard.interface';
import { DashboardIncadeaService } from 'src/services/api-services/dashboardIncadeaBooking.service';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-i-overall-summary',
    templateUrl: './i-overall-summary.component.html',
    styleUrls: ['../../../dashboard/overall-summary/overall-summary.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class IOverallSummaryComponent implements OnInit {
  isExpanded: boolean = false;
  @Output() onToggleExpandCollapseChart: EventEmitter<boolean> = new EventEmitter();

  // Vertical bar chart options
  showXAxisLabel: boolean = true;
  showYAxisLabel: boolean = true;
  legendPosition: LegendPosition = LegendPosition.Below;
  colorScheme: Color = {
    name: 'overallSummaryChartScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#B7CD00', '#00233A', '#16BAE7',
      '#9E61A4', '#F2E500', '#DC7700',
      '#DC9E00', '#0FC9B3', '#7B7A7C']
  };

  graphDashboard$ = new Observable<Graph[]> ()
  dataFilters$ = new Observable<dashboardFilters> ()
  graphAndFilters$ = new Observable<[Graph[], dashboardFilters]> ()
  Datereal = new Date();
  initialDate:string = this.getStartOfWeek()
  finalDate:string = this.getEndOfWeek()
  initialDateNextWeek:string = this.getStartOfNextWeek()
  finalDateNextWeek:string = this.getEndOfNextWeek()
  getFilterDisabled:boolean = false
  ToggleAdvisor:boolean = false;
  locationId:number = 0
  make:string = "0"
  dropdownList:string[]=['CurrentDay','CurrentWeek','NextWeek','CurrentMonth']
  selectDropdown = "CurrentMonth"

   constructor(
    public helperService: HelperService,
    public dashboardIncadeaService: DashboardIncadeaService,
    private translate: TranslateService
   ) {

   }

   ngOnInit(): void {
    // console.log(this.helperService.user)

    this.graphicByRole()

    this.graphAndFilters$ = forkJoin([
      this.graphDashboard$,
      this.dataFilters$
    ]);
   }

   // Method Graphic and Filter Dashboard
   graphicByRole () {

      switch (this.helperService.user.role.roleId) {

        case 3:
          if(!this.getFilterDisabled){
            this.dataFilters$ = this.dashboardIncadeaService?.getIBFilters(this.helperService.user.role.roleId, this.helperService.user.countryId)
            .pipe(shareReplay(1))
            this.getFilterDisabled = true
          }
            this.getDashboardGraph(this.helperService.user.role.roleId, this.helperService.user.countryId, "0")

        break;

        case 4:
          if(!this.getFilterDisabled){
            this.dataFilters$ = this.dashboardIncadeaService?.getIBFilters(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.incadeaCompanyId)
            .pipe(shareReplay(1))
            this.getFilterDisabled = true
          }
            this.getDashboardGraph(this.helperService.user.role.roleId, this.helperService.user.countryId, this.helperService.user.incadeaCompanyId!)

        break;
      }

  }

  getDashboardGraph(roleId:number, countryId:number, specificRole:string)
   {

    let activeAdvisor = 0
    if(this.ToggleAdvisor) activeAdvisor = 1


    switch (this.selectDropdown) {

      case 'CurrentDay':
          this.graphDashboard$ = this.dashboardIncadeaService.getIBGraph(roleId, countryId,
          this.Datereal.getFullYear()+"-"+(this.Datereal.getMonth()+1)+"-"+this.Datereal.getDate(),
          this.Datereal.getFullYear()+"-"+(this.Datereal.getMonth()+1)+"-"+this.Datereal.getDate(),
          specificRole, this.locationId, this.make, 0, activeAdvisor).pipe(
            map((xAxisTicks)=>{
           xAxisTicks.forEach((value)=>{

            value.name=this.translate.instant(value.name)
          //   value.series.forEach((series)=>{
          //   series.name= this.translate.instant(series.name)
          // })
         })
           return xAxisTicks
          }),
          catchError((error) => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }

            return throwError(() => error);
          }
        ))
      break;

      case 'CurrentWeek':
        this.graphDashboard$ = this.dashboardIncadeaService.getIBGraph(roleId, countryId,
          this.initialDate, this.finalDate, specificRole, this.locationId, this.make, 0, activeAdvisor).pipe(
            map((xAxisTicks)=>{
           xAxisTicks.forEach((value)=>{
          if (!this.ToggleAdvisor) {
            value.name=this.translate.instant(value.name.slice(0, 2))
          }
            value.name=this.translate.instant(value.name)
          //   value.series.forEach((series)=>{
          //   series.name= this.translate.instant(series.name)
          // })
         })
           return xAxisTicks
          })),
          catchError((error) => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }

            return throwError(() => error);
          }
        )
      break;

      case 'NextWeek':
        this.graphDashboard$ = this.dashboardIncadeaService.getIBGraph(roleId, countryId,
          this.initialDateNextWeek, this.finalDateNextWeek, specificRole, this.locationId, this.make, 0, activeAdvisor).pipe(
            map((xAxisTicks)=>{
              xAxisTicks.forEach((value)=>{
              if (!this.ToggleAdvisor) {
                value.name=this.translate.instant(value.name.slice(0, 2))
              }
                value.name=this.translate.instant(value.name)
              //   value.series.forEach((series)=>{
              //   series.name= this.translate.instant(series.name)
              // })
              })
              return xAxisTicks
            }),
            catchError((error) => {
              // Manejo de error 401
              if (error.status === 401) {
                this.helperService.logoutToken();
              }

              return throwError(() => error);
            }
          ))
      break;

      case 'CurrentMonth':
        this.graphDashboard$ = this.dashboardIncadeaService.getIBGraph(roleId, countryId,
          this.Datereal.getFullYear()+"-"+
          (this.Datereal.getMonth()+1)+"-"+ 1,this.Datereal.getFullYear()+"-"+ (this.Datereal.getMonth()+1)+"-"+
          this.getLastDayOfMonth(this.Datereal.getFullYear(), this.Datereal.getMonth()), specificRole, this.locationId, this.make, 1, activeAdvisor).pipe(
          map((xAxisTicks)=>{
            xAxisTicks.forEach((value)=>{
            value.name=this.translate.instant(value.name)
            //   value.series.forEach((series,index)=>{
            //   series.name= this.translate.instant(series.name)
            // })
          })
          return xAxisTicks
          }),
          catchError((error) => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }

            return throwError(() => error);
          }
        ))

      break;

    }
  }
    // Method for expand and collapse chart graphic
    expandCollapseChart(toExpand: boolean): void {
      if(toExpand)
        document.getElementsByClassName('legend-labels')[0].classList.add('legend-expanded');
      else
        document.getElementsByClassName('legend-labels')[0].classList.remove('legend-expanded');

      this.isExpanded = toExpand;
      this.onToggleExpandCollapseChart.emit(toExpand);
    }

    getStartOfWeek() {
      const today = new Date();
      const dayOfWeek = today.getDay();
      const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      return new Date(today.setDate(diff)).toISOString().split('T')[0];
    }

    getEndOfWeek() {
      const today = new Date();
      const dayOfWeek = today.getDay();
      const diff = today.getDate() + (6 - dayOfWeek) + (dayOfWeek === 0 ? -6 : 1);
      return new Date(today.setDate(diff)).toISOString().split('T')[0];
    }

    getStartOfNextWeek() {
      const today = new Date();
      const dayOfWeek = today.getDay();
      const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1) + 7; // add 7 days to get next week
      return new Date(today.setDate(diff)).toISOString().split('T')[0];
    }

    getEndOfNextWeek() {
      const today = new Date();
      const dayOfWeek = today.getDay();
      const diff = today.getDate() + (6 - dayOfWeek) + (dayOfWeek === 0 ? -6 : 1) + 7; // add 7 days to get next week
      return new Date(today.setDate(diff)).toISOString().split('T')[0];
    }

    getLastDayOfMonth(year, month) {
      let currentMonth:any = new Date(year, month);
      let nextMonth:any = new Date(year, month + 1);
      let result = (nextMonth - currentMonth)/86400000;
      return result;
    }
}
